/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit více`
};

const da_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Vis mere`
};

const de_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr anzeigen`
};

const en_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Show more`
};

const es_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Ver más`
};

const fr_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Voir plus`
};

const hu_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `További`
};

const it_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra di più`
};

const nl_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Meer tonen`
};

const pl_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Pokaż więcej`
};

const pt_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Ver mais`
};

const sv_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Visa mer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show_more = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show_more(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show_more", locale)
	if (locale === "cs") return cs_show_more(inputs)
	if (locale === "da") return da_show_more(inputs)
	if (locale === "de") return de_show_more(inputs)
	if (locale === "en") return en_show_more(inputs)
	if (locale === "es") return es_show_more(inputs)
	if (locale === "fr") return fr_show_more(inputs)
	if (locale === "hu") return hu_show_more(inputs)
	if (locale === "it") return it_show_more(inputs)
	if (locale === "nl") return nl_show_more(inputs)
	if (locale === "pl") return pl_show_more(inputs)
	if (locale === "pt") return pt_show_more(inputs)
	return sv_show_more(inputs)
};